// src/api/commentService.js

import axios from 'axios';

// Utiliser l'URL de l'API depuis les variables d'environnement
const apiUrl = process.env.REACT_APP_API_URL || 'https://admin.propentatech.com/api/';

// Instance axios pour les requêtes API
const api = axios.create({
  baseURL: apiUrl,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Service pour les commentaires
const commentService = {
  // Récupérer les commentaires d'un événement
  getByEvent: (eventId) => api.get(`/events/${eventId}/comments/`),
  
  // Créer un nouveau commentaire anonyme
  create: (commentData) => {
    console.log("Sending comment data:", commentData);
    
    // Mapper les données au format attendu par l'API
    const apiData = {
      event: commentData.event_id,
      text: commentData.text,
      author_name: commentData.author_name,
      author_email: commentData.author_email || null
    };
    
    return api.post('/comments/', apiData);
  }
};

export default commentService;